/**
 * Primitive border radius tokens
 * Base radius values with no semantic meaning
 *
 * These are the building blocks for border radius throughout the theme.
 * Component tokens and semantic tokens should reference these primitives.
 */
export const borderRadiusPrimitives = {
  none: '0',
  xs: '2px',
  sm: '4px',
  md: '6px',
  lg: '8px',
  xl: '12px',
};

